module.exports = __webpack_public_path__ + "assets/img/Tune_001.5512e2ba-ps.jpg";